import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';

import { useGtmBillingProduct } from '../../hooks';
import {
  setIsGiftCardInsufficientModalOpen,
  setIsGiftCardModalRemoveOpen
} from '../../store/slices/billing';
import { useMediaQuery } from '../../ui/react/src';

export default function GiftcardInsufficientModal() {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery('md');
  const { isGiftCartInsufficientModalOpen } = useAppSelector(
    (state) => state.billing
  );
  const { addExtraPaymentToGiftCardConfirm } = useGtmBillingProduct();

  const onClose = () => {
    addExtraPaymentToGiftCardConfirm();
    dispatch(setIsGiftCardInsufficientModalOpen(false));
  };

  const onRemoveGiftCard = () => {
    onClose();
    dispatch(setIsGiftCardModalRemoveOpen(true));
  };
  return (
    <Modal isOpen={isGiftCartInsufficientModalOpen} onClose={onClose} size="md">
      <ModalHeader
        icon={{
          fill: 'warning-500',
          name: 'warning-circle'
        }}
        onClose={onClose}
        title="Elige un medio de pago adicional"
      />
      <ModalBody className="ui-flex ui-items-center">
        <Text variant="body1" element="p" className="ui-text-center">
          El monto de la compra es superior al de tu Gift Card. Compleméntalo
          con otro medio de pago.
        </Text>
      </ModalBody>
      <ModalFooter>
        <div
          className="ui-flex ui-w-full ui-items-center ui-justify-end ui-gap-2"
          style={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}
        >
          <Button
            feedback="error"
            variant="secondary"
            block={isMobile}
            onClick={onRemoveGiftCard}
          >
            Eliminar Gift Card
          </Button>
          <Button variant="primary" block={isMobile} onClick={onClose}>
            Elegir otro medio de pago
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
